import currency from "./currency";
import giftcardCurrency from "./giftcardCurrency";
import downame from "./downame";
import secure from "./secure";
import timerange from "./timerange";

export default {
  install(Vue) {
    Vue.filter("currency", currency);
    Vue.filter("giftcardCurrency", giftcardCurrency);
    Vue.filter("downame", downame);
    Vue.filter("secure", secure);
    Vue.filter("timerange", timerange);
  },
};
